import React from 'react';
import { UnOrderedListToolbarItem } from "../items/UnOrderedListToolbarItem.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function UnorderedListTiptapItem({
  editor
}) {
  return /*#__PURE__*/_jsx(UnOrderedListToolbarItem, {
    action: () => editor.chain().focus().toggleBulletList().run(),
    on: editor.isActive('bulletList')
  });
}